import irisLogo from './iris-logo-with-name.jpeg'
import  primroseLogo from  './Trillium-health-logo.png' 

export const logoMap = {
  iris: irisLogo,
  primrose: primroseLogo,
};

